module.exports = __webpack_public_path__ + "public/images/Outschool_Logo_Color.20da484d4bc88596df8af0c0f06036de.svg";